import { IRootState } from '../reducer'
import { prefix } from './actions'

export const atlasObjectPreviews = (state: IRootState) => state[prefix]
